import { mapState } from 'pinia';
import stores from 'store/modules';
import OrganizationMixin from '../mixins/organization';

export default {
    mixins: [OrganizationMixin],

    computed: {
        /**
         * Returns true if the add funds component is enabled.
         *
         * @returns {Boolean}
         */
        addFundsDisabled() {
            return !this.billingSources.length;
        },

        ...mapState(stores.User, ['user', 'userPermissions']),
        ...mapState(stores.Number, ['hasNumber']),
        ...mapState(stores.Organization, ['organization']),
        ...mapState(stores.BillingSources, ['billingSources', 'billingSourcesSimple']),
        ...mapState(stores.AddFunds, ['addFundsShown']),
    },

    methods: {
        /**
         * Shows the add funds modal.
         *
         * @return {void}
         */
        showAddFunds() {
            if (this.hasNotBillingSources && !this.isOnTrial) {
                this.showPaymentMethods();

                return;
            }

            if (this.isOnTrial) {
                this.showEarlyUpgrade();

                return;
            }

            this.$store.dispatch('showAddFunds');
        },

        /**
         * Hides the add funds modal.
         *
         * @return {void}
         */
        hideAddFunds() {
            this.$store.dispatch('hideAddFunds');
        },
    },
};
